document.addEventListener("DOMContentLoaded", () => {
  const accordions = document.querySelectorAll(".product-accordion details");

  accordions.forEach((el) => {
    const summary = el.querySelector("summary");
    const content = el.querySelector(".accordion-content");

    let isAnimating = false;

    summary.addEventListener("click", (e) => {
      e.preventDefault();

      if (isAnimating) return;
      isAnimating = true;

      if (!el.open) {
        // OPEN
        el.style.height = el.offsetHeight + "px";
        el.open = true;
        requestAnimationFrame(() => {
          el.style.height = el.offsetHeight + content.offsetHeight + "px";
        });
      } else {
        // CLOSE
        el.style.height = el.offsetHeight + "px";
        requestAnimationFrame(() => {
          el.style.height = summary.offsetHeight + "px";
        });

        setTimeout(() => {
          el.open = false;
        }, 350);
      }

      setTimeout(() => {
        el.style.height = "";
        isAnimating = false;
      }, 400);
    });
  });
});
